import React, {useEffect, useState} from 'react';
import './Login.scss';
import styles from "./Login.module.scss";
import { Link, useNavigate } from "react-router-dom";
import { clearLoginState } from "../Auth.slice";
import { postLogin, authMe } from "../Auth.thunk";
import { ILoginData } from "../Auth.interfaces";
import { useAppDispatch, useAppSelector } from "../../../hooks/hooks";
import SDCLogo from '../../../img/SDCLogo.png';
import banner from "../../../img/mainBanner.png";
//import { GoogleLogin } from "@react-oauth/google";
import HomeTopButtons from "../../../components/Buttons/HomeTopButtons/HomeTopButtons";
import * as R from "../../../common/routes";

interface GoogleTokenPayload {
    email: string;
    name: string;
    picture: string;
}

declare global {
    interface Window {
        AppleID: any;
    }
}

const Login = () => {
    const [email, setEmail] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const [code, setCode] = useState<string>('');
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const { needPassword, is2FA, doAuthMe, loginFinished } = useAppSelector(state => state.Auth);

    //useEffect(() => {
    //    checkIsAuthUser();
    //    const script = document.createElement("script");
    //    script.src = "https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js";
    //    script.async = true;
    //    script.onload = () => {
    //        window.AppleID?.auth?.init({
    //            clientId: "com.your.app.id",
    //            scope: "name email",
    //            redirectURI: "https://your-frontend.com/callback",
    //            usePopup: true,
    //        });
    //    };
    //    document.body.appendChild(script);
    //}, [dispatch]);

    useEffect(() => {
        if (needPassword) {
            navigate(R.PASSWORD)
            dispatch(clearLoginState());
        }
    }, [needPassword, navigate, dispatch]);

    useEffect(() => {
        if (doAuthMe) {
            dispatch(authMe());
            dispatch(clearLoginState());
        }
    }, [doAuthMe, dispatch]);

    useEffect(() => {
        if (loginFinished) {
            navigate(R.MAIN)
            dispatch(clearLoginState());
        }
    }, [loginFinished, navigate, dispatch]);

    const emailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setEmail(event.target.value);
    };

    const passChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setPassword(event.target.value);
    };

    const handleLogin = () => {
        const loginData: ILoginData = {
            email: email,
            password: password,
            code: code
        };
        dispatch(postLogin(loginData));
    };

    const onEnter = (event: React.KeyboardEvent<HTMLDivElement>): void => {
        if (event.key !== 'Enter' || !(email && password)) return;
        event.preventDefault();
        handleLogin();
    };

    return (
        <>
            <div className="login-container" onKeyDown={onEnter}>
                <div className={styles.banner}>
                    <div className={styles.overlay}></div>
                    <img src={banner} alt=""/>
                    <img src={banner} alt=""/>
                </div>
                <div className="login-form">
                    <div className="left">
                        <div className="inputs">
                            <input type="email" onChange={emailChange} placeholder='Username' autoComplete="email" className="input login"/>
                            <input type="password" onChange={passChange} placeholder='Password' autoComplete="current-password" className="input login"/>
                            {is2FA && (
                                <input onChange={(e) => setCode(e.target.value)} placeholder='Code' className="input login" />
                            )}
                        </div>
                        <button
                            type='submit'
                            onClick={() => handleLogin()}
                            className="login-btn">
                            Sign in
                        </button>

                        {/*<div style={{ marginTop: "10px" }}>*/}
                        {/*    <GoogleLogin*/}
                        {/*        onSuccess={handleGoogleLoginSuccess}*/}
                        {/*        onError={() => console.log("Google Login Failed")}*/}
                        {/*    />*/}
                        {/*</div>*/}

                        {/*<div style={{ marginTop: "10px" }}>*/}
                        {/*    <button className={styles.appleLoginBtn} onClick={handleAppleLogin}>*/}
                        {/*        <svg*/}
                        {/*            xmlns="http://www.w3.org/2000/svg"*/}
                        {/*            viewBox="0 0 14 17"*/}
                        {/*            width="18"*/}
                        {/*            height="18"*/}
                        {/*            style={{ marginRight: "8px" }}*/}
                        {/*            fill="white"*/}
                        {/*        >*/}
                        {/*            <path d="M13.962 13.622c-.36.83-.792 1.53-1.3 2.1-.528.602-1.1.91-1.717.924-.437 0-.964-.13-1.582-.385a5.253 5.253 0 0 0-1.557-.384c-.63 0-1.3.13-2 .385-.697.256-1.184.385-1.46.385-.642-.014-1.225-.32-1.748-.924a6.613 6.613 0 0 1-1.267-2.1c-.342-.867-.515-1.716-.515-2.548 0-1.167.26-2.183.78-3.05A4.278 4.278 0 0 1 3.83 6.43c.735-.495 1.526-.74 2.37-.734.466 0 1.08.144 1.84.433a5.244 5.244 0 0 1 1.448.725c.384.26.703.392.96.392.177 0 .43-.11.76-.338.287-.208.535-.365.744-.47l.64-.39c.003.03.018.136.044.317.027.185.04.313.04.39-.014.44-.117.857-.308 1.25-.202.416-.44.78-.715 1.09a5.406 5.406 0 0 1-.94.82c-.26.184-.393.385-.4.605-.007.205.12.456.38.75.267.3.52.625.755.973.238.352.45.74.635 1.164.185.42.29.81.315 1.167a3.8 3.8 0 0 1-.18 1.16zM10.19 0c.01.51-.148 1.003-.474 1.478-.388.563-.892.896-1.513.995a1.55 1.55 0 0 1-.07-.31c-.013-.108-.018-.218-.018-.33.007-.47.173-.92.496-1.35.18-.237.406-.437.678-.6.272-.158.542-.24.81-.246.027.12.05.233.07.336.02.103.02.212 0 .326z"/>*/}
                        {/*        </svg>*/}
                        {/*        <span>Sign in with Apple</span>*/}
                        {/*    </button>*/}

                        {/*</div>*/}

                        <div className={"password-link"}>
                            <Link to={"/password"}>Password Management</Link>
                        </div>
                        <div className={"registration-link"}>
                            <Link to={"/registration"}>Registration</Link>
                        </div>
                    </div>
                    <div className="right">
                        <div className="logo">
                            <img className="logo-img" src={SDCLogo} alt="logo"/>
                        </div>
                        <span className="logo-label">Sport Data Collection</span>
                        {/*{errorMessage && <span className="error">{errorMessage}</span>}*/}
                        <div className="version">office@sportdatacollection.com</div>
                    </div>
                </div>
            </div>
            <HomeTopButtons />
        </>
    );
};

export default Login;
Login.displayName = "Login";

/*    const handleGoogleLoginSuccess = async (credentialResponse: any) => {
        try {
            const { credential } = credentialResponse;
            if (!credential) return;

            const decoded = jwtDecode<GoogleTokenPayload>(credential);
            console.log("Google decoded user:", decoded);

            const response = await api.post("/api/auth/google", {
                idToken: credential,
            });

            const data = response.data;

            sessionStorage.setItem(SS_TOKEN, data.accessToken);
            navigate(R.SCHEDULE);
        } catch (error) {
            console.error("Google login error:", error);
        }
    };

    const handleAppleLogin = async () => {
        try {
            const response = await window.AppleID.auth.signIn();
            const id_token = response.authorization.id_token;

            const res = await api.post("/api/auth/apple", {
                idToken: id_token,
            });

            const data = res.data;
            sessionStorage.setItem(SS_TOKEN, data.accessToken);
            navigate(R.SCHEDULE);
        } catch (error) {
            console.error("Apple login error:", error);
        }
    };

*/